import React from 'react';

import CustomSoftware from './CustomSoftware';
import Awarded from './Awarded';
import DevOps from './DevOps';
import Maintenance from './Maintenance';

const MainView = () => {
  return (
    <div className="simple-service expended main-view text-format">
      <CustomSoftware />
      <Awarded />
      <DevOps />
      <Maintenance />
    </div>
  );
};

export default MainView;
